import styled from '@emotion/styled';
import { Backdrop } from '@mui/material';

/**
 * Contenedor principal de la página de lecciones manuales
 * - Header
 * - Body
 */
export const CoursesLessonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  background-color: transparent;
  gap: 20px;
`;

export const CoursesLessonsBackdrop = styled(Backdrop)`
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
